export default function(item: string): string {
  let name: string = item;
  const translateObject: any = {
    "Contract number": "Номер",
    "Firstname of contract responsible": "Имя ответственного",
    "Lastname of contract responsible": "Фамилия ответственного",
    "Middlename of contract responsible": "Отчество ответственного",
    "Payment conditions": "Условия оплаты",
    "Date of contract creation": "Дата создания",
    "Date of contract formation": "Дата формирования",
    "Count of learning resources":
      "Количество учебных материалов (курсы, записи, вебинары)",
    "Total amount by learning resources": "Общая сумма",
    "Company title": "Название вашей компании",
    "Company short title": "Краткое название вашей компании",
    "Company Inn": "ИНН вашей компании",
    "Company Kpp": "КПП вашей компании",
    "Company Ogrn": "ОГРН вашей компании",
    "Company legal address": "Юридический адрес вашей компании",
    "Company fact address": "Фактический адрес вашей компании",
    "Company payment account": "Расчетный счет вашей компании",
    "Company correspondent account": "Корреспондентский счет вашей компании",
    "Company bank": "Банк вашей компании",
    "Company bik": "БИК вашей компании",
    "Company Okpo": "ОКПО вашей компании",
    "Company Okato": "ОКАТО вашей компании",
    "Company Okved": "ОКВЭД вашей компании",
    "Company director name": "ФИО директора вашей компании",
    "Company director name genetive":
      "ФИО директора вашей компании в родительском падеже",
    "Company director position": "Должность директора вашей компании",
    "Company basis": "На основании чего действует директор вашей компании",
    "Company phones": "Контактные телефоны вашей компании",
    "Company emails": "Email вашей компании",
    "Company sites": "Адрес сайта вашей компании",
    "Contractor title": "Название юридического лица",
    "Contractor short title": "Краткое название юридического лица",
    "Annex contract number":
      "Номер договора, к которому прикреплено приложение",
    "Annex date of contract formation":
      "Дата формирования договора, к которому прикреплено приложение",
    "Juridical contractor title": "Название юридического лица",
    "Juridical contractor short title": "Краткое название юридического лица",
    "Juridical contractor Inn": "ИНН юридического лица",
    "Juridical contractor Kpp": "КПП юридического лица",
    "Juridical contractor Ogrn": "ОГРН юридического лица",
    "Juridical contractor payment account": "Расчетный счет юридического лица",
    "Juridical contractor correspondent account":
      "Корреспондентский счет юридического лица",
    "Juridical contractor bank": "Банк юридического лица",
    "Juridical contractor Bik": "БИК юридического лица",
    "Juridical contractor Okpo": "ОКПО юридического лица",
    "Juridical contractor Okato": "ОКАТО юридического лица",
    "Juridical contractor Okved": "ОКВЭД юридического лица",
    "Juridical contractor legal address": "Юридический адрес лица",
    "Juridical contractor fact address": "Фактический адрес юридического лица",
    "Juridical contractor phone": "Контактные телефоны юридического лица",
    "Juridical contractor email": "Email юридического лица",
    "Juridical contractor site": "Сайт юридического лица",
    "Juridical contractor director name": "ФИО директора юридического лица",
    "Juridical contractor director name genetive":
      "ФИО директора юридического лица в родительском падеже",
    "Juridical contractor director position":
      "Должность директора юридического лица",
    "Juridical contractor basis":
      "На основании чего действует директор юридического лица",
    "Physical contractor username":
      "Логин физического лица (заказчика обучения)",
    "Physical contractor email": "Email физического лица (заказчика обучения)",
    "Physical contractor phone":
      "Контактный телефон физического лица (заказчика обучения)",
    "Physical contractor firstName":
      "Имя физического лица (заказчика обучения)",
    "Physical contractor lastName":
      "Фамилия физического лица (заказчика обучения)",
    "Physical contractor middleName":
      "Отчество физического лица (заказчика обучения)",
    "Physical contractor gender": "Пол физического лица (заказчика обучения)",
    "Physical contractor passport number":
      "Номер паспорта физического лица (заказчика обучения)",
    "Physical contractor passport series":
      "Серия паспорта физического лица (заказчика обучения)",
    "Physical contractor passport issued by":
      "Кем выдан паспорта физического лица (заказчика обучения)",
    "Physical contractor when passport issued":
      "Когда выдан паспорта физического лица (заказчика обучения)",
    "Physical contractor birthday":
      "Дата рождения физического лица (заказчика обучения)",
    "Physical contractor snils": "СНИЛС физического лица (заказчика обучения)",
    "Physical contractor address":
      "Адрес регистрации физического лица (заказчика обучения)",
    "Physical contractor post address":
      "Почтовый адрес физического лица (заказчика обучения)",
    Students: "Список обучающихся",
    "Student email": "Email обучающегося",
    "Student phone": "Контактный телефон обучающегося",
    "Student firstname": "Имя обучающегося",
    "Student lastname": "Фамилия обучающегося",
    "Student middlename": "Отчество обучающегося",
    "Student fullName": "ФИО обучающегося",
    "Student fullname": "ФИО обучающегося",
    "Student photo": "Фото обучающегося",
    "Student gender": "Пол обучающегося",
    "Student birthday": "Дата рождения обучающегося",
    "Student position": "Должность обучающегося",
    "Student education": "Уровень образования обучающегося",
    "Student education series": "Серия документа о ВО/СПО обучающегося",
    "Student education number": "Номер документа о ВО/СПО обучающегося",
    "Student education date": "Дата выдачи документа о ВО/СПО обучающегося",
    "Student education registration number":
      "Регистрационный номер документа о ВО/СПО обучающегося",
    "Student education surname":
      "Фамилия указанная в дипломе о ВО или СПО обучающегося",
    "Student education institution": "Наименование учебного заведения",
    "Student learning resources": "Учебные материалы обучающегося",
    "Student passport series": "Серия паспорта обучающегося",
    "Student passport number": "Номер паспорта обучающегося",
    "Student passport issued by": "Кем выдан паспорт обучающегося",
    "Student snils": "СНИЛС обучающегося",
    "When the passport was issued to the student":
      "Когда выдан паспорт обучающегося",
    "Learning resources": "Список учебных материалов",
    "Learning resource title": "Название учебного материала",
    "Learning resource type":
      "Тип учебного материала (например курс или вебинар)",
    "Learning resource price": "Стоимость учебного материала",
    "Learning resource amount": "Общая сумма учебного материала",
    "Count of students in learning resource":
      "Количество обучающихся по учебному материалу",
    "Enrollment order listeners": "Список обучающихся",
    "Enrollment order number": "Номер",
    "Enrollment order signed": "Дата подписания",
    "Enrollment order created ": "Дата формирования",
    "Enrollment order education started": "Дата начала обучения",
    "Enrollment order education finished": "Дата завершения обучения",
    "Enrollment order owner full name": "ФИО ответственного",
    "Enrollment order owner first name": "Имя ответственного",
    "Enrollment order owner middle name": "Отчество ответственного",
    "Enrollment order owner last name": "Фамилия ответственного",
    "Enrollment order listeners count":
      "Количество обучающихся в приказе о зачислении",
    "Course title": "Название курса",
    "Course hours": "Кол-во часов курса",
    "Course owner full name": "ФИО преподаватель курса",
    "Course owner first name": "Имя преподавателя курса",
    "Course owner middle name": "Отчество преподавателя курса",
    "Course owner last name": "Фамилия преподавателя курса",
    "Course listener first name": "Имя обучающегося",
    "Course listener lastName name": "Фамилия обучающегося",
    "Course listener middle name": "Отчество обучающегося",
    "Course listener fullName name": "ФИО обучающегося",
    "Expulsion order number": "Номер приказа об отчислении",
    "Expulsion order signed": "Дата подписания",
    "Expulsion order created": "Дата формирования",
    "Expulsion order education started": "Дата начала обучения",
    "Expulsion order education finished": "Дата завершения обучения",
    "Expulsion order owner full name": "ФИО ответственного",
    "Expulsion order owner first name": "Имя ответственного",
    "Expulsion order owner middle name": "Отчество ответственного",
    "Expulsion order owner last name": "Фамилия ответственного",
    "Expulsion order listeners count": "Кол-во обучающихся",
    "Expulsion order listeners": "Список обучающихся",
    Number: "Номер",
    Reason: "Причина проверки знаний",
    "Date of creating": "Дата формирования",
    "Date of signing ": "Дата подписания",
    "Course owner firstname": "Имя преподавателя",
    "Course owner lastname": "Фамилия преподавателя",
    "Course owner middlename": "Отчество преподавателя",
    "Protocol owner firstname": "Имя ответственного",
    "Protocol owner lastname": "Фамилия ответственного",
    "Protocol owner middlename": "Отчество ответственного",
    "Protocol number": "Номер протокола",
    "Protocol date of creation": "Дата формирования протокола",
    Expiration: "Действует до",
    "Commission member position": "Должность члена комиссии",
    "Commission chairman firstname": "Имя председателя комиссии",
    "Commission chairman lastname": "Фамилия председателя комиссии",
    "Commission chairman middlename": "Отчество председателя комиссии",
    "Commission secretary firstname": "Имя секретаря комиссии",
    "Commission secretary lastname": "Фамилия секретаря комиссии",
    "Commission secretary middlename": "Отчество секретаря комиссии",
    "Commission members": "Список членов комиссии",
    "Commission member firstname": "Имя члена комиссии",
    "Commission member lastname": "Фамилия члена комиссии",
    "Commission member middlename": "Отчество члена комиссии",
    "Commission chairman position": "Должность председателя комиссии",
    "Commission chairman initials": "Инициалы председателя комиссии",
    "Commission secretary position": "Должность секретаря комиссии",
    "Commission secretary initials": "Инициалы секретаря комиссии",
    "Commission members initials": "Инициалы членов комиссии",
    "Commission member initials": "Инициалы члена комиссии",
    "Students count": "Количество обучающихся",
    "Status of learning": "Статус обучения",
    "Date of course pass": "Дата сдачи курса",
    "Start date of learning": "Дата начала обучения",
    "Is course test passed": "Практическое задание курса сдано",
    "Status of passed practice": "Статус сдачи практического задания",
    "Final documents": "Итоговые документы",
    "Register number of final document": "Регистрационный номер",
    "Register number": "Регистрационный номер",
    Series: "Серия",
    "Date of signing": "Дата подписания",
    "Date of creation": "Дата создания",
    "Date of issued at": "Дата выдачи",
    "Act number": "Номер акта",
    "Date of forming": "Дата формирования",
    "Bill number": "Номер счёта",
    "Enrollment order created": "Дата формирования",
    "Course listener firstname": "Имя обучающегося",
    "Course listener middlename": "Отчество обучающегося",
    "Course listener lastname": "Фамилия обучающегося",
    "Course listener fullname": "ФИО обучающегося",
    "Course listener position": "Должность обучающегося",
    "Bill price": "Сумма",
    "Act price": "Сумма",
    "Student job": "Место работы",
    "Course listener job": "Место работы",
    "Student full name dative": "ФИО обучающегося в дательном падеже",
    "Student first name dative": "Имя обучающегося в дательном падеже",
    "Student last name dative": "Фамилия обучающегося в дательном падеже",
    "Student middle name dative": "Отчество обучающегося в дательном падеже",
    "Student start education": "Дата начала обучения",
    "Student address": "Адрес регистрации обучающегося",
    "Student postAddress": "Почтовый адрес обучающегося",
    "Assigned qualification rank":
      "Присвоенный квалификационный разряд, класс, категория",
    email: "Email",
    username: "Логин",
    firstName: "Имя",
    lastName: "Фамилия",
    middleName: "Отчество",
    password: "Пароль",
    newPassword: "Новый пароль",
    oldPassword: "Старый пароль",
    plainPassword: "Пароль",
    phone: "Телефон",
    phones: "Телефоны",
    users: "Пользователи",
    number: "Номер",
    title: "Название",
    clientType: "Тип контрагента",
    clientId: "ID контрагента",
    signedAt: "Подписан",
    educationStartedAt: "Дата начала обучения",
    listeners: "Студенты",
    protocol: "Протокол",
    "Original number": "Номер дубликата",
    "Original series": "Серия дубликата",
    "Original register number": "Регистрационный номер дубликата",
    "Learning resource hours": "Количество часов учебного материала"
  };

  for (let key in translateObject) {
    if (translateObject.hasOwnProperty(key)) {
      if (key === name) {
        name = translateObject[key];
      }
    }
  }

  return name;
}
